/**
 * Debug utility for iframe-messenger-v2
 * Uses optional consumer-provided debug callback instead of hardcoded console logging
 */

type DebugCallback = (message: string, ...args: any[]) => void;

let globalDebugCallback: DebugCallback | undefined;

/**
 * Set the debug callback for iframe-messenger operations
 * Called internally by managers when initialized with debug config
 */
export const setDebugCallback = (callback: DebugCallback | undefined) => {
  globalDebugCallback = callback;
};

/**
 * Internal debug logging - only logs if consumer provided a debug callback
 */
export const debug = (message: string, ...args: any[]) => {
  if (globalDebugCallback) {
    globalDebugCallback(message, ...args);
  }
};